// @aide-title Folder contents
// @aide-description Browse the folders and documents inside a workspace folder, and upload, move, rename, share, download or delete them
// @aide-rule Every segment after /workspace is a folder slug, "<reference>-<first 10 characters of the folder name with spaces as hyphens>" (e.g. /workspace/MT001-Head-Offic/MT014-Leases), so a link can only be built for a folder whose reference is known
import React from "react";
import { MaplesPage } from "components/pages";
import { useLocation } from "react-router-dom";
import { extractWorkspaceIds } from "features/System/TreeMenu";
import { WorkspaceContent } from "features/Workspace/WorkspaceContent";
import { AppRoutes } from "constants/routes";
import * as Breadcrumbs from "constants/breadcrumbs";

const WorkspaceContentPage = () => {
  const location = useLocation();

  const ids = extractWorkspaceIds(location.pathname);
  const lastId = ids.length > 0 ? ids[ids.length - 1] : null;

  // TODO: use lookup to get header details about item for building breadcrumbs?

  return (
    <MaplesPage headerItems={["Workspace Item"]}>
      <WorkspaceContent
        path={ids.splice(1, ids.length)}
        rootSource={AppRoutes.Workspace}
        rootBreadcrumbs={[
          { content: Breadcrumbs.Workspace, to: AppRoutes.Workspace },
        ]}
      />
    </MaplesPage>
  );
};

export default WorkspaceContentPage;
